import React, { Component } from 'react'
import { Button, Divider, Grid, Container, Typography, Box } from "@material-ui/core";
import LogOutButton from "../Helpers/LogOutButton";
import './frontPage.css'
import Footer from '../Helpers/Footer';
import AvailableSpace from '../Helpers/AvailableSpace';
import HowSopiaCanHelp from '../Helpers/HowSopiaCanHelp';
import { withRouter } from 'react-router-dom';
import Header from '../Header';
import MapView from "./mapView";
import axios from "axios";
import { baseUrl } from "../../actions/utils";
import { RESIDENCE_TYPES } from "../../constants";

const propertyImages = [
    require("../../images/png/office1.jpg"),
    require("../../images/png/office2.jpg"),
    require("../../images/png/office7.jpg"),
    require("../../images/png/office5.jpg"),
    require("../../images/png/office6.jpg"),
    require("../../images/png/office3.jpg")
]

const ImageFromId = (id) => {
    if (!id) return propertyImages[0]
    const parsed = parseInt("1" + id.toString().replaceAll(/[^0-9]/g, ""))
    return propertyImages[parsed % propertyImages.length]
}

const translateResidenceType = (residenceType) => {
    if (!residenceType)
        return "-";
    let result = ""
    if (typeof residenceType === "string")
        result = [RESIDENCE_TYPES.find(item => item.value === residenceType)]
    if (Array.isArray(residenceType))
        result = residenceType
            .map(type => RESIDENCE_TYPES.find(item => item.value === type))
    result = result.map(type => type ? type.displayName : undefined)
        .filter(Boolean)
        .join(", ")
    return result;
}

class FrontPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            announcements: []
        };
    }

    componentDidMount() {
        axios.get(`${baseUrl}/announcement`)
            .then(res => {
                let data = res.data || [];
                // Sort by most recent first, or just slice latest 6
                data = data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)).slice(0, 6)

                // Format announcements into AvailableSpace item structure
                const formatted = data.map(anno => ({
                    id: anno.id,
                    title: anno.properties.address || "Helsinki",
                    spaceType: translateResidenceType(anno.properties.residenceType),
                    price: anno.properties.rent ? `${anno.properties.rent} € / kk` : "Ask for price",
                    size: anno.properties.size ? `${anno.properties.size} m²` : "-",
                    imageSrc: ImageFromId(anno.properties.id)
                }));
                this.setState({ announcements: formatted });
            })
            .catch(err => console.log("Error fetching announcements:", err));
    }

    handleRedirect = () => {
        // Accessing history object via withRouter
        this.props.history.push('/signup/tenant/0'); // Replace '/new page' with your desired URL
    };
    render() {
        const { loggedIn, user } = this.props;


        return (
            <>
                <Header admin={user.isAdmin} loggedIn={loggedIn} />

                <Container maxWidth="100%" disableGutters>
                    <div className='mobile-cover-container'>
                        <Typography style={{ color: 'black', fontWeight: 'bold' }} variant="h3" align="center" className="landingpic-text-black">Commercial Premises for Rent</Typography>
                        <Typography style={{ fontWeight: 'bold' }} variant="h3" align="center" className="landingpic-text-white">Makes the Best Matches!</Typography>
                    </div>

                    <div className='cover-section'>
                        <div style={{ paddingBottom: '4rem' }}>
                            <Typography variant="h2" align="center"
                                style={{ color: 'black', fontWeight: 'bold' }} className="landingpic-text-black"
                            >Commercial Premises for Rent</Typography>
                            <Typography variant="h2" align="center" style={{ color: 'white', fontWeight: 'bold', fontSize: '5rem' }} className="landingpic-text-white" >Sopia Makes the Best Matches!</Typography>
                        </div>
                    </div>
                    {/*
                    <TextField
                    onClick={this.handleRedirect}
                    className='search-bar-input'
                    id="input-with-icon-textfield"
                    variant='filled'
                    placeholder='Enter an address, neighborhood, city, or ZIP code'
                    InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                        <SearchIcon />
                        </InputAdornment>
                    ),
                    }}
                />

                */
                    }

                </Container>

                {/* <Container>
                    <MapView />
                </Container> */}

                <Container maxWidth="lg" >
                    <Box
                        sx={{

                            pt: 8,
                            pb: 6,
                        }}
                    >
                        <Container maxWidth="md" style={{ maxWidth: '870px' }}>
                            <Typography
                                variant="h3"
                                align="center"
                                color="secondary"
                                style={{ fontWeight: 'bold' }}
                                gutterBottom

                            >
                                Browse Available Premises
                            </Typography>
                            <Typography variant="h5" align="center" color="secondary" paragraph>
                                Sopia provides an open platform with fully automated
                                matchmaking experience for both tenants and property owners.
                            </Typography>
                        </Container>
                    </Box>

                    <Grid container spacing={4}>
                        {this.state.announcements.map((item) => (
                            <AvailableSpace key={item.id} item={item} />
                        ))}
                    </Grid>
                    <Box display="flex" justifyContent="center" pt={4} pb={8}>
                        <Button variant="contained" size="medium" color='primary'> VIEW MORE</Button>
                    </Box>

                    <Box mt={2} mb={8}>
                        <Divider variant="middle" />
                    </Box>

                    <Box>
                        <HowSopiaCanHelp />
                    </Box>
                </Container>

                <Container maxWidth="100%" disableGutters>
                    <Box sx={{ pt: 20 }}>
                        <Footer />
                    </Box>
                </Container>
            </>
        );
    }
}
// Wrap the component with withRouter to access the history object
export default withRouter(FrontPage);
